// extracted by mini-css-extract-plugin
export var bubble = "_30-0";
export var container = "_30-f";
export var contrastBorder = "_30-g";
export var greyOut = "_30-2";
export var initialsColor0 = "_30-3";
export var initialsColor1 = "_30-4";
export var initialsColor10 = "_30-d";
export var initialsColor11 = "_30-e";
export var initialsColor2 = "_30-5";
export var initialsColor3 = "_30-6";
export var initialsColor4 = "_30-7";
export var initialsColor5 = "_30-8";
export var initialsColor6 = "_30-9";
export var initialsColor7 = "_30-a";
export var initialsColor8 = "_30-b";
export var initialsColor9 = "_30-c";
export var initialsWrapper = "_30-1";
export var large = "_30-l";
export var medium = "_30-k";
export var mediumSmall = "_30-j";
export var mediumSmallMedium = "_30-o";
export var micro = "_30-h";
export var small = "_30-i";
export var tiny = "_30-n";
export var xTiny = "_30-m";